import React, { useState, useEffect } from "react";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import { TableData, TableGroupProps, TRow, TData } from "../..";

export const generateTableBody = (data: TableData) =>
  data.map((row) => row.map((cell) => cell.value));

const TableBody = ({ data }: TableGroupProps) => {
  const [tableRows, setTableRows] = useState<string[][]>([]);

  useEffect(() => {
    if (!data) return;
    setTableRows(generateTableBody(data));
  }, [data]);

  return (
    <tbody>
      {tableRows.map((row, rowIndex) => (
        <TRow key={rowIndex}>
          {row.map((cell, cellIndex) => (
            <TData key={cellIndex}>
              <Paragraph size="small" weight="book">
                {cell}
              </Paragraph>
            </TData>
          ))}
        </TRow>
      ))}
    </tbody>
  );
};

export default TableBody;
